import { createApiClient } from './apiClient';
import { config } from '../config';

const apiClient = createApiClient({
    baseURL: config.bffUrl + '/api/',
});

const getSessionTokenFromCookie = () => {
    const match = document.cookie.match(/(^| )hanko=([^;]+)/);
    return match ? match[2] : null;
};

export const fetchNotifications = async (page = 0, size = 20) => {
    const response = await apiClient.get(`notifications?page=${page}&size=${size}`);
    return response.data;
};

export const fetchUnreadNotificationCount = async () => {
    const response = await apiClient.get('notifications/unread-count');
    return response.data?.count ?? 0;
};

export const markNotificationsRead = async (ids) => {
    const response = await apiClient.post('notifications/mark-read', { ids });
    return response.data;
};

export const markAllNotificationsRead = async () => {
    const response = await apiClient.post('notifications/mark-all-read');
    return response.data;
};


export const archiveNotifications = async (ids) => {
    const response = await apiClient.post('notifications/archive', { ids });
    return response.data;
};

export const archiveAllNotifications = async () => {
    const response = await apiClient.post('notifications/archive-all');
    return response.data;
};
export const openNotificationStream = async ({ signal } = {}) => {
    const token = getSessionTokenFromCookie();
    if (!token) {
        throw new Error('No session token found in cookie');
    }
    const response = await fetch(`${config.bffUrl}/api/notifications/stream`, {
        method: 'GET',
        headers: {
            Accept: 'text/event-stream',
            Authorization: `Bearer ${token}`,
        },
        signal,
    });
    if (!response.ok) {
        throw new Error(`Notification stream failed: ${response.status}`);
    }
    return response;
};